// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    webGetV1Healthcheck (params?: {}): Promise<Dict>;
    v1PublicGetMarkets (params?: {}): Promise<Dict>;
    v1PublicGetTickers (params?: {}): Promise<Dict>;
    v1PublicGetTicker (params?: {}): Promise<Dict>;
    v1PublicGetSymbols (params?: {}): Promise<Dict>;
    v1PublicGetDepthResult (params?: {}): Promise<Dict>;
    v1PublicGetHistory (params?: {}): Promise<Dict>;
    v1PublicGetKline (params?: {}): Promise<Dict>;
    v1PrivatePostAccountBalance (params?: {}): Promise<Dict>;
    v1PrivatePostOrderNew (params?: {}): Promise<Dict>;
    v1PrivatePostOrderCancel (params?: {}): Promise<Dict>;
    v1PrivatePostOrders (params?: {}): Promise<Dict>;
    v1PrivatePostAccountOrderHistory (params?: {}): Promise<Dict>;
    v1PrivatePostAccountExecutedHistory (params?: {}): Promise<Dict>;
    v1PrivatePostAccountExecutedHistoryAll (params?: {}): Promise<Dict>;
    v1PrivatePostAccountOrder (params?: {}): Promise<Dict>;
    v2PublicGetMarkets (params?: {}): Promise<Dict>;
    v2PublicGetTicker (params?: {}): Promise<Dict>;
    v2PublicGetAssets (params?: {}): Promise<Dict>;
    v2PublicGetFee (params?: {}): Promise<Dict>;
    v2PublicGetDepthMarket (params?: {}): Promise<Dict>;
    v2PublicGetTradesMarket (params?: {}): Promise<Dict>;
    v4PublicGetAssets (params?: {}): Promise<Dict>;
    v4PublicGetCollateralMarkets (params?: {}): Promise<Dict>;
    v4PublicGetFee (params?: {}): Promise<Dict>;
    v4PublicGetFundingHistoryMarket (params?: {}): Promise<List>;
    v4PublicGetOrderbookDepthMarket (params?: {}): Promise<Dict>;
    v4PublicGetOrderbookMarket (params?: {}): Promise<Dict>;
    v4PublicGetTicker (params?: {}): Promise<Dict>;
    v4PublicGetTradesMarket (params?: {}): Promise<List>;
    v4PublicGetTime (params?: {}): Promise<Dict>;
    v4PublicGetPing (params?: {}): Promise<List>;
    v4PublicGetMarkets (params?: {}): Promise<List>;
    v4PublicGetFutures (params?: {}): Promise<Dict>;
    v4PublicGetPlatformStatus (params?: {}): Promise<Dict>;
    v4PublicGetMiningPool (params?: {}): Promise<Dict>;
    v4PrivatePostCollateralAccountBalance (params?: {}): Promise<Dict>;
    v4PrivatePostCollateralAccountBalanceSummary (params?: {}): Promise<List>;
    v4PrivatePostCollateralAccountPositionsHistory (params?: {}): Promise<List>;
    v4PrivatePostCollateralAccountLeverage (params?: {}): Promise<Dict>;
    v4PrivatePostCollateralAccountPositionsOpen (params?: {}): Promise<List>;
    v4PrivatePostCollateralAccountSummary (params?: {}): Promise<Dict>;
    v4PrivatePostCollateralAccountFundingHistory (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountAddress (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountBalance (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountCreateNewAddress (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountCodes (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountCodesApply (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountCodesMy (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountCodesHistory (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountFiatDepositUrl (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountHistory (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountWithdraw (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountWithdrawPay (params?: {}): Promise<List>;
    v4PrivatePostMainAccountTransfer (params?: {}): Promise<List>;
    v4PrivatePostMainAccountSmartPlans (params?: {}): Promise<List>;
    v4PrivatePostMainAccountSmartInvestment (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountSmartInvestmentClose (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountSmartInvestments (params?: {}): Promise<Dict>;
    v4PrivatePostMainAccountFee (params?: {}): Promise<List>;
    v4PrivatePostMainAccountSmartInterestPaymentHistory (params?: {}): Promise<Dict>;
    v4PrivatePostTradeAccountBalance (params?: {}): Promise<Dict>;
    v4PrivatePostTradeAccountExecutedHistory (params?: {}): Promise<Dict | List>;
    v4PrivatePostTradeAccountOrderHistory (params?: {}): Promise<Dict>;
    v4PrivatePostTradeAccountOrder (params?: {}): Promise<Dict>;
    v4PrivatePostOrderCollateralLimit (params?: {}): Promise<Dict>;
    v4PrivatePostOrderCollateralMarket (params?: {}): Promise<Dict>;
    v4PrivatePostOrderCollateralStopLimit (params?: {}): Promise<Dict>;
    v4PrivatePostOrderCollateralTriggerMarket (params?: {}): Promise<Dict>;
    v4PrivatePostOrderCollateralBulk (params?: {}): Promise<List>;
    v4PrivatePostOrderNew (params?: {}): Promise<Dict>;
    v4PrivatePostOrderMarket (params?: {}): Promise<Dict>;
    v4PrivatePostOrderStockMarket (params?: {}): Promise<Dict>;
    v4PrivatePostOrderStopLimit (params?: {}): Promise<Dict>;
    v4PrivatePostOrderStopMarket (params?: {}): Promise<Dict>;
    v4PrivatePostOrderCancel (params?: {}): Promise<Dict>;
    v4PrivatePostOrderCancelAll (params?: {}): Promise<List>;
    v4PrivatePostOrderKillSwitch (params?: {}): Promise<Dict>;
    v4PrivatePostOrderKillSwitchStatus (params?: {}): Promise<List>;
    v4PrivatePostOrderBulk (params?: {}): Promise<List>;
    v4PrivatePostOrderModify (params?: {}): Promise<Dict>;
    v4PrivatePostOrderConditionalCancel (params?: {}): Promise<List>;
    v4PrivatePostOrders (params?: {}): Promise<List>;
    v4PrivatePostOcoOrders (params?: {}): Promise<List>;
    v4PrivatePostOrderCollateralOco (params?: {}): Promise<Dict>;
    v4PrivatePostOrderOcoCancel (params?: {}): Promise<Dict>;
    v4PrivatePostOrderOtoCancel (params?: {}): Promise<List>;
    v4PrivatePostProfileWebsocketToken (params?: {}): Promise<Dict>;
    v4PrivatePostConvertEstimate (params?: {}): Promise<Dict>;
    v4PrivatePostConvertConfirm (params?: {}): Promise<Dict>;
    v4PrivatePostConvertHistory (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountCreate (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountDelete (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountEdit (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountList (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountTransfer (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountBlock (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountUnblock (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountBalances (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountTransferHistory (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountApiKeyCreate (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountApiKeyEdit (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountApiKeyDelete (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountApiKeyList (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountApiKeyReset (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountApiKeyIpAddressList (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountApiKeyIpAddressCreate (params?: {}): Promise<Dict>;
    v4PrivatePostSubAccountApiKeyIpAddressDelete (params?: {}): Promise<Dict>;
    v4PrivatePostMiningRewards (params?: {}): Promise<Dict>;
    v4PrivatePostMarketFee (params?: {}): Promise<Dict>;
    v4PrivatePostConditionalOrders (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
